import { addDays, isAfter } from 'date-fns';
import { LogType } from '@swagger/humanresources';
import { IN_BERLIN, toBerlin } from '@shared/berlin-time';
import { ReportTaskStatus } from './fis-report.const';
import { ReportRowError } from './report-row-error.interface';

/** Final milestones map to a status; a run without one is still running. */
export function toReportTaskStatus(milestone: LogType | null | undefined): ReportTaskStatus {
  switch (milestone) {
    case LogType.Succeeded:
      return ReportTaskStatus.Ready;
    case LogType.Failed:
    case LogType.Aborted:
      return ReportTaskStatus.Failed;
    default:
      return ReportTaskStatus.Running;
  }
}

/** A failed run, and a finished one whose file is gone, can be started again (#5248). */
export function isRestartable(status: ReportTaskStatus): boolean {
  return status === ReportTaskStatus.Failed || status === ReportTaskStatus.Expired;
}

/** The row error's text, unless it belongs to a status the run has left. */
export function rowErrorText(
  error: ReportRowError | undefined,
  status: ReportTaskStatus,
): string | null {
  if (!error || (error.onlyWhile && error.onlyWhile !== status)) return null;
  return error.text;
}

/** Whether a run started at `createdAt` still has its file (or is still running). */
export function isWithinRetention(
  createdAt: string | null | undefined,
  now: Date,
  retentionDays: number,
): boolean {
  if (!createdAt) return true;
  return isAfter(addDays(toBerlin(createdAt), retentionDays, IN_BERLIN), now);
}
